import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Layout from "../../components/Layout.js";
import { useLocation } from "react-router-dom";
import { apiFetch } from "../../api.js";
import Select from "react-select";

const StaffMasterDetailsDesign = () => {
  const allowAlphabets = (v) => v.replace(/[^a-zA-Z ]/g, "");
  const allowNumbers = (v) => v.replace(/[^0-9]/g, "");
  const validateEmail = (value) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
  const [emailError, setEmailError] = useState("");
  const navigate = useNavigate();
  const [Name, setName] = useState("");
  const [Address, setAddress] = useState("");
  const [ZipCode, setZipCode] = useState("");
  const [AadharNo, setAadharNo] = useState("");
  const [PANNo, setPANNo] = useState("");
  const [Phoneno, setPhoneno] = useState("");
  const [MobileNo, setMobileNo] = useState("");
  const [Emailno, setEmailno] = useState("");
  const [CtcperMonth, setCtcperMonth] = useState("");
  const [DateOfBirthday, setDateOfBirthday] = useState("");
  const [Joiningdate, setJoiningdate] = useState("");
  const [Anniversary, setAnniversary] = useState("");
  const [Trainingday, setTrainingday] = useState("");
  const [Trainingtype, setTrainingtype] = useState("");
  const [Trainingfrom, setTrainingfrom] = useState("");
  const [Trainingto, setTrainingto] = useState("");
  const [ResignationDate, setResignationDate] = useState("");
  const [State, setState] = useState("");
  const [StateList, setStateList] = useState([]);
  const [City, setCity] = useState("");
  const [CityList, setCityList] = useState([]);
  const [Area, setArea] = useState("");
  const [AreaList, setAreaList] = useState([]);
  const [Department, setDepartment] = useState("");
  const [DepartmentList, setDepartmentList] = useState([]);
  const [Headname, setHeadname] = useState("");
  const [HeadnameList, setHeadnameList] = useState([]);
  const [Designation, setDesignation] = useState("");
  const [DesignationList, setDesignationList] = useState([]);
  const [Vehicleno, setVehicleno] = useState("");
  const [VehiclenoList, setVehiclenoList] = useState([]);
  const [showDeptModal, setShowDeptModal] = useState(false);
  const [newDepartment, setNewDepartment] = useState("");
  const [showDesignationModal, setShowDesignationModal] = useState(false);
  const [newDesignationCode, setNewDesignationCode] = useState("");
  const [newDesignationName, setNewDesignationName] = useState("");
  const [isMechanic, setIsMechanic] = useState(false);
  const routerLocation = useLocation();
  const editUnqid = routerLocation.state?.unqid || null;
  const [editData, setEditData] = useState(null);
  const [gridRows, setGridRows] = useState([]);
  const [isEditing, setIsEditing] = useState(false);
  const [ipAddress, setIpAddress] = useState("");
  const storedUserInfo = JSON.parse(sessionStorage.getItem("userinfo")) || {};

  const customStyles = {
    control: (base) => ({
      ...base,
      minHeight: "40px",
      height: "40px",
      borderRadius: "5px",
      borderColor: "#ccc",
      boxShadow: "none",
      fontSize: "14px",
    }),
    valueContainer: (base) => ({
      ...base,
      height: "40px",
      padding: "0 10px",
      display: "flex",
      alignItems: "center",
    }),
    indicatorsContainer: (base) => ({
      ...base,
      height: "40px",
    }),
    input: (base) => ({
      ...base,
      margin: 0,
      padding: 0,
    }),
  };
  const buttonContainerStyle = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: "14px",
    flexWrap: "nowrap", // 🔥 no wrapping (forces one row)
    width: "100%",
    marginTop: "30px",
    position: "relative",
    zIndex: 10,
  };

  const buttonStyle = (bgColor) => ({
    minWidth: "120px",
    height: "44px",
    padding: "0 18px",
    backgroundColor: bgColor,
    color: "#fff",
    border: "none",
    borderRadius: "6px",
    cursor: "pointer",
    fontWeight: "bold",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    whiteSpace: "nowrap",
  });

  useEffect(() => {
    apiFetch("/api/get-ip")
      .then((res) => res.json())
      .then((data) => setIpAddress(data.ip))
      .catch(() => setIpAddress("0.0.0.0"));
  }, []);

  //Exit code
  const handleExit = () => {
    navigate("/StaffMasterGrid");
  };

  // Fetch State City Area
  useEffect(() => {
    fetchStates();
  }, []);
  const fetchStates = async () => {
    try {
      const response = await apiFetch(
        "/api/staffmaster/states",
        { method: "POST" },
      );
      const data = await response.json();
      const formatted = data.map((x) => ({ label: x.value, value: x.label }));
      setStateList(formatted);
    } catch (err) {
      console.error("Error fetching states:", err);
    }
  };

  useEffect(() => {
    if (State) fetchCities(State);
  }, [State]);
  const fetchCities = async (stateValue) => {
    try {
      const response = await apiFetch(
        "/api/staffmaster/cities",
        { method: "POST", body: JSON.stringify({ stateValue }) },
      );
      const data = await response.json();
      const formatted = data.map((x) => ({ label: x.label, value: x.value }));
      setCityList(formatted);
    } catch (err) {
      console.error("Error fetching cities:", err);
    }
  };

  useEffect(() => {
    if (City) fetchAreas(City);
  }, [City]);
  const fetchAreas = async (cityValue) => {
    try {
      const response = await apiFetch(
        "/api/staffmaster/areas",
        { method: "POST", body: JSON.stringify({ cityValue }) },
      );
      const data = await response.json();
      const formatted = data.map((x) => ({ label: x.label, value: x.value }));
      setAreaList(formatted);
    } catch (err) {
      console.error("Error fetching areas:", err);
    }
  };

  //--------------------------------------Departementlist,Designation,HeadName Fetch
  useEffect(() => {
    fetchdepartementlist();
    fetchdesignationlist();
    fetchheadnamelist();
    fetchvehiclelist();
  }, []);
  const fetchdepartementlist = async () => {
    try {
      const response = await apiFetch(
        "/api/departement/list",
      );
      const data = await response.json();
      setDepartmentList(data.map((x) => ({ label: x.label, value: x.value })));
    } catch (error) {
      console.error("Error fetching department list:", error);
    }
  };

  const fetchdesignationlist = async () => {
    try {
      const response = await apiFetch(
        "/api/designation/list",
      );
      const data = await response.json();
      setDesignationList(data.map((x) => ({ label: x.label, value: x.value })));
    } catch (error) {
      console.error("Error fetching Designation list:", error);
    }
  };

  const fetchheadnamelist = async () => {
    try {
      const response = await apiFetch(
        "/api/headname/list",
      );
      const data = await response.json();
      setHeadnameList(data.map((x) => ({ label: x.label, value: x.value })));
    } catch (error) {
      console.error("Error fetching Headname list:", error);
    }
  };

  const fetchvehiclelist = async () => {
    try {
      const response = await apiFetch(
        "/api/vehicle/list",
      );
      const data = await response.json();
      setVehiclenoList(data.map((x) => ({ label: x.label, value: x.value })));
    } catch (error) {
      console.error("Error fetching vehicle list:", error);
    }
  };

  //-------------------Save Working
  const handleSave = async () => {
    try {
      if (!validateEmail(Emailno)) {
        alert("Please enter a valid email address");
        return;
      }
      const payload = {
        prefix: "",
        what: "insert",
        mcm_11: "",
        mcm_12: ipAddress,
        mcm_13: storedUserInfo.userid || "",
        mcm_14: "",
        mcm_15: Name,
        mcm_16: Address,
        mcm_17: Area,
        mcm_18: City,
        mcm_19: State,
        mcm_20: CtcperMonth,
        mcm_21: ZipCode,
        mcm_22: AadharNo,
        mcm_23: PANNo,
        mcm_24: DateOfBirthday,
        mcm_25: Anniversary,
        mcm_26: Phoneno,
        mcm_27: MobileNo,
        mcm_28: Joiningdate,
        mcm_29: ResignationDate,
        mcm_30: Trainingfrom,
        mcm_31: Trainingto,
        mcm_32: Vehicleno,
        mcm_33: Trainingtype,
        mcm_34: Trainingday,
        mcm_35: Designation,
        mcm_36: Headname,
        mcm_37: Department,
        mcm_38: "",
        mcm_39: "",
        mcm_40: Emailno,
      };

      const res = await apiFetch(
        "/api/mechanicmaster/save",
        { method: "POST", body: JSON.stringify(payload) },
      );
      const data = await res.json();
      if (data.err === "Save successfully") {
        alert("✔ Saved Successfully!");
      } else {
        alert("❌ Error: " + JSON.stringify(data));
      }
      navigate("/StaffMasterGrid");
    } catch (error) {
      console.log("Save Error:", error);
      alert("Server Error");
    }
  };
  //----------Edit Working
  useEffect(() => {
    if (editUnqid) {
      setIsEditing(true);
      fetchEditData(editUnqid);
    }
  }, [editUnqid]);

  const fetchEditData = async (unqid) => {
    try {
      const response = await apiFetch(
        "/api/mechanicmaster/edit",
        { method: "POST", body: JSON.stringify({ unqid }) },
      );
      const d = await response.json();
      const toInputDate = (val) => {
        if (!val || val === "null") return "";
        const [dd, mm, yyyy] = val.split("/");
        return `${yyyy}-${mm}-${dd}`;
      };
      setEditData(d);
      setName(d.name);
      setAddress(d.addr);
      setArea(d.area_unq);
      setCity(d.city_unq);
      setState(d.state);
      setZipCode(d.zipcode);
      setAadharNo(d.aadharno);
      setPANNo(d.panno);
      setPhoneno(d.phoneno);
      setMobileNo(d.mobile);
      setEmailno(d.Email);
      setDateOfBirthday(toInputDate(d.dob));
      setJoiningdate(toInputDate(d.dobjoining));
      setAnniversary(toInputDate(d.dom));
      setResignationDate(toInputDate(d.dobreg));
      setCtcperMonth(d.CTC || "");
      setTrainingfrom(toInputDate(d.trainingfrom));
      setTrainingto(toInputDate(d.trainingto));
      setTrainingday(d.trainingdays);
      setTrainingtype(d.type);
      setVehicleno(d.vehi_unq);
      setDepartment(d.dep_unq);
      setDesignation(d.mcm_35.toLowerCase());
      setHeadname(d.stf);
    } catch (err) {
      console.error("Edit fetch error", err);
    }
  };

  //------------Update Working-------------
  const handleUpdate = async () => {
    try {
      if (!editUnqid) {
        alert("Invalid record");
        return;
      }

      if (!validateEmail(Emailno)) {
        alert("Please enter a valid email address");
        return;
      }

      const payload = {
        prefix: "",
        what: "update",

        mcm_11: "",
        mcm_12: ipAddress,
        mcm_13: storedUserInfo.userid || 0,

        mcm_14: editUnqid,

        mcm_15: Name,
        mcm_16: Address,
        mcm_17: Area,
        mcm_18: City,
        mcm_19: State,
        mcm_20: CtcperMonth,
        mcm_21: ZipCode,
        mcm_22: AadharNo,
        mcm_23: PANNo,
        mcm_24: DateOfBirthday,
        mcm_25: Anniversary,
        mcm_26: Phoneno,
        mcm_27: MobileNo,
        mcm_28: Joiningdate,
        mcm_29: ResignationDate,
        mcm_30: Trainingfrom,
        mcm_31: Trainingto,
        mcm_32: Vehicleno,
        mcm_33: Trainingtype,
        mcm_34: Trainingday,
        mcm_35: Designation,
        mcm_36: Headname,
        mcm_37: Department,
        mcm_38: "",
        mcm_39: "",
        mcm_40: Emailno,
      };

      const res = await apiFetch(
        "/api/mechanicmaster/update",
        { method: "POST", body: JSON.stringify(payload) },
      );
      const data = await res.json();
      if (data.err === "Save successfully") {
        alert("✔ Updated Successfully!");
        navigate("/StaffMasterGrid");
      } else {
        alert("❌ " + data.err);
      }
    } catch (err) {
      console.error("Update Error:", err);
      alert("Server Error");
    }
  };

  return (
    <Layout>
      <div className="page-container">
        <div className="container">
          <div className="header">Staff Master</div>

          {/* ---------------- FORM ROW 1 ---------------- */}
          <div className="form-row">
            <div className="form-column">
              <label>Name</label>
              <input
                type="text"
                value={Name}
                onChange={(e) => setName(allowAlphabets(e.target.value))}
              />
            </div>
            <div className="form-column">
              <label>Address</label>
              <input
                type="text"
                value={Address}
                onChange={(e) => setAddress(e.target.value)}
              />
            </div>
          </div>
          {/* ---------------- FORM ROW 2 ---------------- */}
          <div className="form-row">
            <div className="form-column">
              <label>Zip Code</label>
              <input
                type="text"
                value={ZipCode}
                onChange={(e) => setZipCode(e.target.value)}
              />
            </div>
            <div className="form-column">
              <label>State</label>
              <Select
                options={StateList}
                value={StateList.find((s) => s.value === State) || null}
                onChange={(selected) => {
                  setState(selected?.value || "");
                  setCity("");
                  setArea("");
                }}
                styles={customStyles}
                placeholder="Select"
                isSearchable
                menuPortalTarget={document.body}
                menuPosition="fixed"
              />
            </div>
            <div className="form-column">
              <label>City</label>
              <Select
                options={CityList}
                value={CityList.find((c) => c.value === City) || null}
                onChange={(selected) => {
                  setCity(selected?.value || "");
                  setArea(""); // reset area when city changes
                }}
                styles={customStyles}
                placeholder="Select"
                isSearchable
                menuPortalTarget={document.body}
                menuPosition="fixed"
              />
            </div>
            <div className="form-column">
              <label>Area</label>
              <Select
                options={AreaList}
                value={AreaList.find((a) => a.value === Area) || null}
                onChange={(selected) => setArea(selected?.value || "")}
                styles={customStyles}
                placeholder="Select"
                isSearchable
                menuPortalTarget={document.body}
                menuPosition="fixed"
              />
            </div>
          </div>

          {/* ---------------- FORM ROW 3 ---------------- */}
          <div className="form-row">
            <div className="form-column">
              <label>Aadhar No</label>
              <input
                type="text"
                value={AadharNo}
                onChange={(e) => setAadharNo(allowNumbers(e.target.value))}
              />
            </div>
            <div className="form-column">
              <label>PAN No</label>
              <input
                type="text"
                value={PANNo}
                onChange={(e) => setPANNo(e.target.value)}
              />
            </div>
            <div className="form-column">
              <label>Phone No</label>
              <input
                type="text"
                value={Phoneno}
                maxLength={10}
                onChange={(e) => {
                  const val = allowNumbers(e.target.value);
                  if (val.length <= 10) setPhoneno(val);
                }}
              />
            </div>
            <div className="form-column">
              <label>Mobile No</label>
              <input
                type="text"
                value={MobileNo}
                maxLength={10}
                onChange={(e) => {
                  const val = allowNumbers(e.target.value);
                  if (val.length <= 10) setMobileNo(val);
                }}
              />
            </div>
          </div>

          {/* ---------------- Row 4 ---------------- */}
          <div className="form-row">
            <div className="form-column">
              <label>Email</label>
              <input
                type="text"
                value={Emailno}
                onChange={(e) => {
                  const val = e.target.value;
                  setEmailno(val);

                  if (val.trim() === "") {
                    setEmailError("Email is required");
                  } else if (!validateEmail(val)) {
                    setEmailError("Invalid email format");
                  } else {
                    setEmailError("");
                  }
                }}
              />

              {emailError && (
                <span style={{ color: "red", fontSize: "12px" }}>
                  {emailError}
                </span>
              )}
            </div>

            <div className="form-column">
              <label>Date Of Birthday</label>
              <input
                type="date"
                value={DateOfBirthday}
                onChange={(e) => setDateOfBirthday(e.target.value)}
              />
            </div>
            <div className="form-column">
              <label>Joining Date</label>
              <input
                type="date"
                value={Joiningdate}
                onChange={(e) => setJoiningdate(e.target.value)}
              />
            </div>
            <div className="form-column">
              <label>Department</label>

              <div
                style={{ display: "flex", gap: "5px", alignItems: "center" }}
              >
                <div style={{ flex: 1 }}>
                  <Select
                    options={DepartmentList}
                    value={
                      DepartmentList.find((d) => d.value === Department) || null
                    }
                    onChange={(selected) =>
                      setDepartment(selected?.value || "")
                    }
                    styles={customStyles}
                    placeholder="Select"
                    isSearchable
                    menuPortalTarget={document.body}
                    menuPosition="fixed"
                  />
                </div>

                {/* ➕ Add Department Button (UNCHANGED) */}
                <button
                  type="button"
                  onClick={() => setShowDeptModal(true)}
                  style={{
                    width: "35px",
                    height: "35px",
                    background: "#8B1E3F",
                    color: "white",
                    borderRadius: "5px",
                    border: "none",
                    cursor: "pointer",
                    fontSize: "20px",
                  }}
                >
                  +
                </button>
              </div>
            </div>
          </div>

          {/* ---------------- Row 5 ---------------- */}
          <div className="form-row">
            <div className="form-column">
              <label>CTC(Per Month)</label>
              <input
                type="text"
                value={CtcperMonth}
                onChange={(e) => setCtcperMonth(e.target.value)}
              />
            </div>
            <div className="form-column">
              <label>Head Name</label>
              <Select
                options={HeadnameList}
                value={HeadnameList.find((h) => h.value === Headname) || null}
                onChange={(selected) => setHeadname(selected?.value || "")}
                styles={customStyles}
                placeholder="Select"
                isSearchable
                menuPortalTarget={document.body}
                menuPosition="fixed"
              />
            </div>
            <div className="form-column">
              <label>Designation</label>

              <div
                style={{
                  display: "flex",
                  gap: "5px",
                  alignItems: "center",
                }}
              >
                <div style={{ flex: 1 }}>
                  <Select
                    options={DesignationList}
                    value={
                      DesignationList.find((d) => d.value === Designation) ||
                      null
                    }
                    onChange={(selected) => {
                      const value = selected?.value || "";
                      setDesignation(value);

                      if (selected?.label?.toUpperCase() === "MECHANIC") {
                        setIsMechanic(true);
                      } else {
                        setIsMechanic(false);
                        setTrainingfrom("");
                        setTrainingto("");
                        setTrainingday("");
                        setTrainingtype("");
                        setVehicleno("");
                      }
                    }}
                    styles={customStyles}
                    placeholder="Select"
                    isSearchable
                    menuPortalTarget={document.body}
                    menuPosition="fixed"
                  />
                </div>

                <button
                  type="button"
                  onClick={() => setShowDesignationModal(true)}
                  style={{
                    width: "35px",
                    height: "35px",
                    background: "#8B1E3F",
                    color: "white",
                    borderRadius: "5px",
                    border: "none",
                    cursor: "pointer",
                    fontSize: "20px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  +
                </button>
              </div>
            </div>

            <div className="form-column">
              <label>Anniversary</label>
              <input
                type="date"
                value={Anniversary}
                onChange={(e) => setAnniversary(e.target.value)}
              />
            </div>
          </div>
          {/* ---------------- Row 6 ---------------- */}
          <div className="form-row">
            <div className="form-column">
              <label>Resignation Date</label>
              <input
                type="date"
                value={ResignationDate}
                onChange={(e) => setResignationDate(e.target.value)}
              />
            </div>
            <div className="form-column"></div>
            <div className="form-column"></div>
            <div className="form-column"></div>
          </div>
          {/* ---------------- In Case of Mechanic ---------------- */}
          <div className="header1">In Case of Mechanic</div>
          <div className="form-row">
            <div className="form-column">
              <label>Training From</label>
              <input
                type="date"
                value={Trainingfrom}
                disabled={!isMechanic}
                onChange={(e) => setTrainingfrom(e.target.value)}
              />
            </div>

            <div className="form-column">
              <label>Training To</label>
              <input
                type="date"
                value={Trainingto}
                disabled={!isMechanic}
                onChange={(e) => setTrainingto(e.target.value)}
              />
            </div>

            <div className="form-column">
              <label>Training Day's</label>
              <input
                type="text"
                value={Trainingday}
                disabled={!isMechanic}
                onChange={(e) => setTrainingday(e.target.value)}
              />
            </div>

            <div className="form-column">
              <label>Training Type</label>
              <input
                type="text"
                value={Trainingtype}
                disabled={!isMechanic}
                onChange={(e) => setTrainingtype(e.target.value)}
              />
            </div>

            <div className="form-column">
              <label>Vehicle Name</label>
              <Select
                options={VehiclenoList}
                value={VehiclenoList.find((v) => v.value === Vehicleno) || null}
                onChange={(selected) => setVehicleno(selected?.value || "")}
                styles={customStyles}
                placeholder="Select"
                isSearchable
                isDisabled={!isMechanic}
                menuPortalTarget={document.body}
                menuPosition="fixed"
              />
            </div>
          </div>
          {/* ---------------- Designation ---------------- */}
          <div className="header1">Designation</div>
          {/* ---------------- TABLE ---------------- */}
          <div className="table-container">
            <div className="container">
              <table>
                <thead>
                  <tr>
                    <th>S.N</th>
                    <th>Date</th>
                    <th>Department</th>
                    <th>Designation</th>
                    <th>Head Name</th>
                    <th>Ctc</th>
                  </tr>
                </thead>
                <tbody>
                  {gridRows.map((row, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>{row.Date}</td>

                      <td>{row.Department}</td>
                      <td>{row.Designation}</td>
                      <td>{row.HeadName}</td>
                      <td>{row.Ctc}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
          {/* ---------------- BUTTONS ---------------- */}
          <div style={buttonContainerStyle}>
            {!isEditing && (
              <button style={buttonStyle("#4caf50")} onClick={handleSave}>
                Save
              </button>
            )}
            {isEditing && (
              <button
                className="btn-save"
                style={buttonStyle("#2e20abff")}
                onClick={handleUpdate}
              >
                Update
              </button>
            )}

            <button style={buttonStyle("#ab2025")} onClick={handleExit}>
              Exit
            </button>
          </div>
        </div>
      </div>

      {/* ----------------------------------------------------
            CSS EXACTLY LIKE INSURANCE MASTER / RATE MASTER
      ---------------------------------------------------- */}
      <style>
        {`
 .rs__menu-portal{
  z-index:9999!important;
}

/* ================= PAGE ================= */

.page-container{
  width:100%;
  min-height:100vh;
  background:#f4f6f8;
  display:flex;
  justify-content:center;
  padding:10px;
}

.container{
  width:100%;
  max-width:100%;
  background:#fff;
  border-radius:8px;
  padding:15px;
  box-shadow:0 4px 8px rgba(0,0,0,.1);
}

.header,.header1{
  text-align:center;
  font-size:1.5rem;
  font-weight:bold;
  padding:15px;
  background:#8B1E3F;
  color:#fff;
  border-radius:6px;
  margin-bottom:20px;
}

.header1{height:60px}

/* ================= FORM GRID ================= */

/* Desktop default = 4 */

.form-row{
  display:grid;
  grid-template-columns:repeat(4,1fr);
  gap:15px;
  margin-bottom:15px;
}

.form-column{
  display:flex;
  flex-direction:column;
}

label{
  font-size:14px;
  font-weight:600;
  margin-bottom:4px;
}

input,select{
  height:40px!important;
  width:100%!important;
  padding:8px 10px;
  border:1px solid #ccc;
  border-radius:5px;
  background:#fff;
  font-size:14px;
  box-sizing:border-box;
}

/* ================= RESPONSIVE ================= */

/* Laptop = 3 */
@media(max-width:1400px){
  .form-row{grid-template-columns:repeat(3,1fr);}
}

/* iPad = 2 */
@media(max-width:1024px){
  .form-row{grid-template-columns:repeat(2,1fr);}
}

/* Mobile = 1 */
@media(max-width:600px){
  .form-row{grid-template-columns:1fr;}

  .page-container,
  .container{
    width:100%!important;
    max-width:100%!important;
    padding:10px;
  }

  .App{
    text-align:left!important;
  }
}

/* ================= TABLE ================= */

.table-container{
  overflow-x:auto;
  margin-top:25px;
  border:1px solid #ddd;
  border-radius:6px;
}

table{
  width:max-content;
  min-width:100%;
  border-collapse:collapse;
  font-size:13px;
  table-layout:fixed;
}

th{
  background:#f8bcbc;
  padding:10px;
  border:1px solid #ccc;
  white-space:nowrap;
  text-align:center;
  position:sticky;
  top:0;
  z-index:2;
}

td{
  border:1px solid #ccc;
  padding:6px;
  text-align:center;
  min-width:110px;
}

/* ================= BUTTONS (FIXED) ================= */

.button-container{
  width:100%;
  display:flex;
  justify-content:center;
  align-items:center;
  gap:15px;
  margin-top:25px;
  flex-wrap:wrap;
}

.btn-save{
  background:#4caf50;
  color:#fff;
  border:none;
  padding:10px 25px;
  border-radius:5px;
  font-weight:600;
  cursor:pointer;
  min-width:140px;
}

.btn-exit{
  background:#a20d0d;
  color:#fff;
  border:none;
  padding:10px 25px;
  border-radius:5px;
  font-weight:600;
  cursor:pointer;
  min-width:140px;
}

/* Keep buttons in ONE ROW even on mobile */
@media(max-width:600px){
  .button-container{
    flex-direction:row;
  }
}


`}
      </style>
      {showDeptModal && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            background: "rgba(0,0,0,0.6)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
          }}
        >
          <div
            style={{
              width: "90%",
              maxWidth: "450px",
              background: "white",
              borderRadius: "6px",
              boxShadow: "0 4px 12px rgba(0,0,0,0.3)",
            }}
          >
            {/* ---------------- HEADER ---------------- */}
            <div
              style={{
                background: "#8B1E3F",
                color: "white",
                padding: "12px 15px",
                fontSize: "20px",
                fontWeight: "bold",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                borderTopLeftRadius: "6px",
                borderTopRightRadius: "6px",
              }}
            >
              <span>Add Department</span>

              <span
                onClick={() => setShowDeptModal(false)}
                style={{
                  cursor: "pointer",
                  fontSize: "22px",
                  fontWeight: "bold",
                }}
              >
                ✖
              </span>
            </div>

            {/* ---------------- BODY ---------------- */}
            <div style={{ padding: "20px" }}>
              {/* LABEL + INPUT INLINE FIX */}
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginBottom: "15px",
                  gap: "20px",
                }}
              >
                <label
                  style={{
                    width: "150px",
                    fontWeight: 600,
                    fontSize: "14px",
                  }}
                >
                  Department Name :
                </label>

                <input
                  type="text"
                  value={newDepartment}
                  onChange={(e) => setNewDepartment(e.target.value)}
                  style={{
                    flex: 1,
                    height: "38px",
                    padding: "8px",
                    border: "1px solid #ccc",
                    borderRadius: "5px",
                  }}
                />
              </div>

              {/* BUTTONS */}
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  gap: "15px",
                  marginTop: "10px",
                }}
              >
                <button
                  onClick={() => {
                    if (newDepartment.trim() === "") {
                      alert("Enter Department Name");
                      return;
                    }

                    apiFetch(
                        "/api/departement/insert",
                        {
                          method: "POST",
                          body: JSON.stringify({ DepartmentName: newDepartment }),
                        },
                      )
                      .then((res) => res.json())
                      .then((data) => {
                        if (data.err === "E01") {
                          alert("Duplicate Department!");
                          return;
                        }

                        if (data.err === "0") {
                          alert("Department Saved!");

                          // ✅ create option ONCE
                          const newOption = {
                            value: data.id,
                            label: newDepartment,
                          };

                          // ✅ add to react-select list
                          setDepartmentList((prev) => [...prev, newOption]);

                          // ✅ auto-select newly added department
                          setDepartment(data.id);

                          setShowDeptModal(false);
                          setNewDepartment("");
                        }
                      })
                      .catch(() => alert("Server Error"));
                  }}
                  style={{
                    background: "green",
                    color: "white",
                    padding: "8px 20px",
                    borderRadius: "5px",
                    border: "none",
                    cursor: "pointer",
                    fontWeight: "bold",
                  }}
                >
                  Save
                </button>

                <button
                  onClick={() => setShowDeptModal(false)}
                  style={{
                    background: "red",
                    color: "white",
                    padding: "8px 20px",
                    borderRadius: "5px",
                    border: "none",
                    cursor: "pointer",
                    fontWeight: "bold",
                  }}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* ==================== DESIGNATION POPUP ==================== */}
      {showDesignationModal && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            background: "rgba(0,0,0,0.6)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
          }}
        >
          <div
            style={{
              width: "90%",
              maxWidth: "450px",
              background: "white",
              borderRadius: "6px",
              boxShadow: "0 4px 12px rgba(0,0,0,0.3)",
            }}
          >
            {/* HEADER */}
            <div
              style={{
                background: "#8B1E3F",
                color: "white",
                padding: "12px 15px",
                fontSize: "20px",
                fontWeight: "bold",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                borderTopLeftRadius: "6px",
                borderTopRightRadius: "6px",
              }}
            >
              <span>Add Designation</span>

              <span
                onClick={() => setShowDesignationModal(false)}
                style={{
                  cursor: "pointer",
                  fontSize: "22px",
                  fontWeight: "bold",
                }}
              >
                ✖
              </span>
            </div>

            {/* BODY */}
            {/* ---------------- BODY ---------------- */}
            <div style={{ padding: "20px" }}>
              {/* Row - Code */}
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginBottom: "15px",
                  gap: "20px",
                }}
              >
                <label style={{ width: "120px", fontWeight: 600 }}>
                  Code :
                </label>

                <select
                  value={newDesignationCode}
                  onChange={(e) => setNewDesignationCode(e.target.value)}
                  style={{
                    flex: 1,
                    height: "35px",
                    padding: "5px",
                    borderRadius: "4px",
                    border: "1px solid #ccc",
                  }}
                >
                  <option value="">Select</option>
                  <option value="00">00</option>
                  <option value="01">01</option>
                  <option value="02">02</option>
                  <option value="03">03</option>
                </select>
              </div>

              {/* Row - Designation */}
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginBottom: "20px",
                  gap: "20px",
                }}
              >
                <label style={{ width: "120px", fontWeight: 600 }}>
                  Designation :
                </label>

                <input
                  type="text"
                  value={newDesignationName}
                  onChange={(e) => setNewDesignationName(e.target.value)}
                  style={{
                    flex: 1,
                    height: "35px",
                    padding: "5px",
                    borderRadius: "4px",
                    border: "1px solid #ccc",
                  }}
                />
              </div>

              {/* BUTTONS */}
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  gap: "15px",
                }}
              >
                <button
                  onClick={async () => {
                    if (!newDesignationCode || !newDesignationName.trim()) {
                      alert("Please enter all fields");
                      return;
                    }

                    try {
                      const res = await apiFetch(
                        "/api/designation/insert",
                        {
                          method: "POST",
                          body: JSON.stringify({
                            code: newDesignationCode,
                            name: newDesignationName,
                          }),
                        },
                      );
                      const data = await res.json();
                      if (data.err === "E01: Duplicate Code/Designation") {
                        alert(
                          "❌ Duplicate Designation or Code already exists!",
                        );
                        return;
                      }

                      if (data.err === "Save successfully") {
                        alert("✔ Designation Saved!");

                        // ✅ create option
                        const newOption = {
                          value: newDesignationName,
                          label: newDesignationName,
                        };

                        // ✅ add to react-select list
                        setDesignationList((prev) => [...prev, newOption]);

                        // ✅ auto-select newly added designation
                        setDesignation(newDesignationName);

                        // ✅ mechanic auto check
                        if (newDesignationName.toUpperCase() === "MECHANIC") {
                          setIsMechanic(true);
                        } else {
                          setIsMechanic(false);
                          setTrainingfrom("");
                          setTrainingto("");
                          setTrainingday("");
                          setTrainingtype("");
                          setVehicleno("");
                        }

                        // ✅ close popup & reset
                        setShowDesignationModal(false);
                        setNewDesignationCode("");
                        setNewDesignationName("");
                      }
                    } catch (error) {
                      alert("Server Error");
                      console.log(error);
                    }
                  }}
                  style={{
                    background: "green",
                    color: "white",
                    padding: "8px 22px",
                    borderRadius: "5px",
                    border: "none",
                    cursor: "pointer",
                    fontWeight: "bold",
                  }}
                >
                  Save
                </button>

                <button
                  onClick={() => setShowDesignationModal(false)}
                  style={{
                    background: "red",
                    color: "white",
                    padding: "8px 22px",
                    borderRadius: "5px",
                    border: "none",
                    cursor: "pointer",
                    fontWeight: "bold",
                  }}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </Layout>
  );
};

export default StaffMasterDetailsDesign;
